var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveCourse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33674 11.3758L6.40313 13.3094L12.6187 19.525L26.4313 5.7125L24.4976 3.77888L12.6187 15.5883L8.33674 11.3758ZM25.05 14C25.05 20.0774 20.0773 25.05 14 25.05C7.9227 25.05 2.95 20.0774 2.95 14C2.95 7.92263 7.92263 2.95 14 2.95C15.0359 2.95 16.0719 3.08826 17.039 3.36444L19.1797 1.22344C17.5914 0.532812 15.8648 0.1875 14 0.1875C6.40312 0.1875 0.1875 6.40312 0.1875 14C0.1875 21.5969 6.40312 27.8125 14 27.8125C21.5969 27.8125 27.8125 21.5969 27.8125 14H25.05Z",
    fill: "#663399"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCourse);
export default __webpack_public_path__ + "static/media/activeCourse.5455ffc99e6b0ae55be7546a37072113.svg";
export { ForwardRef as ReactComponent };